export const EMAIL_CAMPAIGNS__CREATE = 'EMAIL_CAMPAIGNS__CREATE';
export const EMAIL_CAMPAIGNS__DELETE = 'EMAIL_CAMPAIGNS__DELETE';
export const EMAIL_CAMPAIGNS__FETCH = 'EMAIL_CAMPAIGNS__FETCH';
export const EMAIL_CAMPAIGNS__RESET_CSV = 'EMAIL_CAMPAIGNS__RESET_CSV';
export const EMAIL_CAMPAIGNS__UPDATE = 'EMAIL_CAMPAIGNS__UPDATE';
export const EMAIL_CAMPAIGNS__UPLOAD = 'EMAIL_CAMPAIGNS__UPLOAD';

export const EMAIL_CAMPAIGNS__CLOSE_DOWNLOAD_MODAL = 'EMAIL_CAMPAIGNS__CLOSE_DOWNLOAD_MODAL';

export const EMAIL_CAMPAIGNS__MESSAGES_CREATE = 'EMAIL_CAMPAIGNS__MESSAGES_CREATE';
export const EMAIL_CAMPAIGNS__MESSAGES_FETCH = 'EMAIL_CAMPAIGNS__MESSAGES_FETCH';
export const EMAIL_CAMPAIGNS__MESSAGES_SEND = 'EMAIL_CAMPAIGNS__MESSAGES_SEND';
export const EMAIL_CAMPAIGNS__MESSAGES_UPDATE = 'EMAIL_CAMPAIGNS__MESSAGES_UPDATE';

export const EMAIL_CAMPAIGNS__PARTICIPANTS_CREATE = 'EMAIL_CAMPAIGNS__PARTICIPANTS_CREATE';
export const EMAIL_CAMPAIGNS__PARTICIPANTS_DELETE = 'EMAIL_CAMPAIGNS__PARTICIPANTS_DELETE';
export const EMAIL_CAMPAIGNS__PARTICIPANTS_DOWNLOAD = 'EMAIL_CAMPAIGNS__PARTICIPANTS_DOWNLOAD';
export const EMAIL_CAMPAIGNS__PARTICIPANTS_UPDATE = 'EMAIL_CAMPAIGNS__PARTICIPANTS_UPDATE';
export const EMAIL_CAMPAIGNS__PARTICIPANTS_FETCH = 'EMAIL_CAMPAIGNS__PARTICIPANTS_FETCH';
export const EMAIL_CAMPAIGNS__PARTICIPANTS_RESET_CHECKED =
  'EMAIL_CAMPAIGNS__PARTICIPANTS_RESET_CHECKED';
export const EMAIL_CAMPAIGNS__PARTICIPANTS_TOGGLE = 'EMAIL_CAMPAIGNS__PARTICIPANTS_TOGGLE';
export const EMAIL_CAMPAIGNS__PARTICIPANTS_TOGGLE_ALL = 'EMAIL_CAMPAIGNS__PARTICIPANTS_TOGGLE_ALL';

export const EMAIL_CAMPAIGNS__PARTICIPANTS_PROMPT_DOWNLOAD =
  'EMAIL_CAMPAIGNS__PARTICIPANTS_PROMPT_DOWNLOAD';

export const EMAIL_CAMPAIGNS__FETCH_MAILCHIMP_LISTS = 'EMAIL_CAMPAIGNS__FETCH_MAILCHIMP_LISTS';
export const EMAIL_CAMPAIGNS__FETCH_MAILCHIMP_GROUPS = 'EMAIL_CAMPAIGNS__FETCH_MAILCHIMP_GROUPS';
export const EMAIL_CAMPAIGNS__FETCH_MAILCHIMP_SEGMENTS =
  'EMAIL_CAMPAIGNS__FETCH_MAILCHIMP_SEGMENTS';
export const EMAIL_CAMPAIGNS__DOWNLOAD_MAILCHIMP_LIST = 'EMAIL_CAMPAIGNS__DOWNLOAD_MAILCHIMP_LIST';
export const EMAIL_CAMPAIGNS__UPLOAD_MAILCHIMP_LIST = 'EMAIL_CAMPAIGNS__UPLOAD_MAILCHIMP_LIST';
export const EMAIL_CAMPAIGNS__CREATE_MAILCHIMP_WEBHOOK =
  'EMAIL_CAMPAIGNS__CREATE_MAILCHIMP_WEBHOOK';
export const EMAIL_CAMPAIGNS__DELETE_MAILCHIMP_WEBHOOK =
  'EMAIL_CAMPAIGNS__DELETE_MAILCHIMP_WEBHOOK';
